import { Component } from "react"
import PropTypes from "prop-types"
import "./style.scss"

class Dot extends Component {
  static propTypes = {
    style: PropTypes.object,
    subscribe: PropTypes.func.isRequired,
    unsubscribe: PropTypes.func.isRequired,
    findDotCoordinates: PropTypes.func.isRequired,
  }

  constructor(...args) {
    super(...args)

    this.state = { showToolTip: false }
  }

  mouseMove = ({ showToolTip, nativeEvent }) => {
    this.setState({ showToolTip, nativeEvent })
  }

  componentDidMount() {
    this.props.subscribe(this.mouseMove)
  }

  componentWillUnmount() {
    this.props.unsubscribe(this.mouseMove)
  }

  render() {
    const { style, findDotCoordinates } = this.props
    const { showToolTip, nativeEvent } = this.state

    if (showToolTip) {
      const coordinates = findDotCoordinates(nativeEvent.offsetX)
      if (coordinates) {
        const { cx, cy } = coordinates

        return <g className="components_charts_dot">
          <circle r="4" {...{ style, cx, cy }} />
          <circle r="8" {...{ style, cx, cy }} className="selected" />
        </g>
      }
    }
    return null
  }
}

export default Dot
